var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoEstrela01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "star",
    d: "M35.4,13.9c-0.2-0.7-0.9-1.2-1.6-1.3l-10.1-0.9l-4-9.3c-0.4-0.9-1.5-1.4-2.4-1c-0.4,0.2-0.8,0.5-1,1l-4,9.3 L2.2,12.6c-1,0.1-1.8,1-1.7,2c0,0.5,0.3,0.9,0.6,1.2l7.6,6.7l-2.2,9.9c-0.2,1,0.4,2,1.4,2.2c0.5,0.1,1,0,1.4-0.2l8.7-5.2l8.7,5.2 c0.9,0.5,2,0.2,2.5-0.6c0.2-0.4,0.3-0.9,0.2-1.4l-2.2-9.9l7.6-6.7C35.4,15.4,35.6,14.6,35.4,13.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEstrela01);
export default __webpack_public_path__ + "static/media/ico-estrela-01.d324e53da8b3acec906b67ea6aad06c5.svg";
export { ForwardRef as ReactComponent };